import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  stepperContainer: {
    padding: "25px 5px 30px 0",
    backgroundColor: "transparent",
    [theme.breakpoints.down("sm")]: {
      padding: "25px 5px 10px 0",
    },
    "& .MuiStepConnector-alternativeLabel": {
      left: "calc(-50% + 12px)",
      right: "calc(50% + 12px)",
      "@media (max-width:450px)": {
        left: "calc(-50% + 14px)",
        right: "calc(50% + 14px)",
        top: 12,
      },
    },
    "& .MuiStepConnector-line": {
      borderColor: "#00A806",
      borderTopWidth: "2px",
    },
    "& .MuiStepConnector-root.Mui-disabled .MuiStepConnector-line": {
      borderColor: "#919191",
    },
    "& .MuiStep-root.Mui-disabled .MuiStepLabel-label": {
      color: "#525252",
    },
  },
  stepAlternativeLabel: {
    "& .MuiStepLabel-label.Mui-active": {
      fontWeight: "bold",
    },
    "@media (max-width:960px)": {
      width: "10vw",
    },
  },
}));
